import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { BehaviorSubject, Observable, tap } from "rxjs";
import { SnackBarConfig } from "../../constants/snackbar.constants";
import { MatSnackBar } from "@angular/material/snack-bar";
import { BaseWishlist, WishListAttributes } from "@models/wishlist.model";
import { ProductAttributes } from "@models/product.model";

@Injectable({
    providedIn: "root",
})
export class WishlistService {
    public wishlistCountSubject = new BehaviorSubject(0);
    public wishlistCount$: Observable<number> = this.wishlistCountSubject.asObservable();
    public wishlistIDS!: { productIDs: number[] };
    constructor(
        private http: HttpClient,
        private snackBar: MatSnackBar,
    ) {}

    public getWishlistedProducts(): Observable<{ productIDs: number[] }> {
        return this.http.get<{ productIDs: number[] }>(
            `${environment.apiUrlBasePath}/wishlist/getWishListedProductIds`,
        );
    }

    public getWishListItems(
        skip: number = 0,
        pageSize: number = 10,
    ): Observable<{ rows: WishListAttributes[]; count: number }> {
        return this.http.get<{ rows: WishListAttributes[]; count: number }>(
            `${environment.apiUrlBasePath}/wishlist/getWishListItems?pageSize=${pageSize}&skip=${skip}`,
        );
    }

    public addToWishList(ProductID: number): Observable<string> {
        const body: BaseWishlist = { productId: ProductID };
        return this.http.post<string>(`${environment.apiUrlBasePath}/wishlist/add`, body).pipe(
            tap((response) => {
                if (response) {
                    this.wishlistIDS.productIDs = [...this.wishlistIDS.productIDs, ProductID];
                    this.wishlistCountSubject.next(this.wishlistIDS.productIDs.length);
                    this.snackBar.open(response, SnackBarConfig.Actions.CLOSE, {
                        duration: SnackBarConfig.Duration.MEDIUM,
                    });
                }
            }),
        );
    }

    public loadMyWishlistItems(): void {
        this.getWishlistedProducts().subscribe((response) => {
            this.wishlistIDS = response;
            this.wishlistCountSubject.next(this.wishlistIDS.productIDs.length);
        });
    }

    public get getAllwishlistIDs(): { productIDs: number[] } {
        return this.wishlistIDS;
    }

    public deleteFromMyWishlist(productID: number): Observable<string> {
        return this.http.delete<string>(`${environment.apiUrlBasePath}/wishlist/delete/${productID}`).pipe(
            tap((response) => {
                if (response) {
                    this.wishlistIDS.productIDs = this.wishlistIDS.productIDs.filter((id: number) => id !== productID);
                    this.wishlistCountSubject.next(this.wishlistIDS.productIDs.length);
                }
            }),
        );
    }

    public resetWishlist(): void {
        this.wishlistIDS.productIDs = [];
        this.wishlistCountSubject.next(this.wishlistIDS.productIDs.length);
    }
}
